let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cEmX3")).then(() => parcelRequire('id4Dk'));